<template>
	<div class="message-reply">
		<label class="uk-form-label header">Compose Message <span class="uk-align-right uk-margin-remove">{{ reply.length }}/{{ messageMaxSize }}</span></label>
		<div class="uk-form-controls">
			<textarea class="uk-textarea" name="message" v-model="reply" maxlength="160" :disabled="sending"></textarea>
		</div>
		<button class="uk-button uk-button-primary" type="button" @click="submitReply" :disabled="sending">
			<i v-if="!sending" class="fas fa-comment fa-flip-horizontal"></i>
			<i v-if="sending" class="fas fa-sync-alt fa-spin"></i>
			Send
		</button>
		<button class="uk-button uk-button-tertiary" type="button" @click="cancelReply"><i class="fas fa-times"></i> Cancel</button>
	</div>
</template>

<script>
export default {
	name: "SMSReplyField",
	components: {},
	props: {
		message:{
			type: Object,
			default: null
		}
	},
	data() {
		return {
			reply:"",
			messageMaxSize:160,
			sending: false,
		};
	},
	mounted() {
	},
	methods: {
		submitReply(){
			this.sending = true;
			axios.post("/api/message/reply/" + this.message.id, {
				message:this.reply
			}).then(() => this.updateReply());
		},
		updateReply(){
			this.sent = false;
			this.$emit("sent", this.message);
		},
		cancelReply() {
			this.$emit("cancel", this.message)
		}
	},
}
</script>

<style scoped>

</style>
